import styled from 'styled-components';

import { PriceText } from '../../../shared/PriceText';

export const StyledReceptionServicePriceText = styled(PriceText)`
   text-align: right;
   color: ${(props) => props.theme.placeholder};
`;

StyledReceptionServicePriceText.displayName = 'StyledReceptionServicePriceText';
